import { render } from "./Login_start.vue?vue&type=template&id=19ecceda"
import script from "./Login_start.vue?vue&type=script&lang=js"
export * from "./Login_start.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__